import React from 'react';
import {
	Button,
	Grid,
	MenuItem,
	TextField
} from '@mui/material';
import DeleteSvg from 'shared/statics/svg/Delete.svg';
import styled from 'styled-components';

const ChipsArray = ({ timing, removeTiming }) => {
	return (
		<RecipientList>
			{timing.map((data) => {
				const singularForm = (data.timing === 'Days Before') ? 'Day Before' : 'Day After';
				const text = (data.days === '1') ? singularForm : data.timing;
				return (<div key={`${data.days}_${data.timing}`}>
					<label>{`${data.days} ${text}`}</label>
					<DeleteIcon onClick={() => removeTiming(data)} />
				</div>);
			})}
		</RecipientList>
	);
};

export default function Timing({ form }) {
	const { values, setFieldValue } = form;
	const [selectedTiming, setSelectedTiming] = React.useState('');
	const [days, setDays] = React.useState();
	const notificationsTimes = [{ name: 'Days Before' }, { name: 'Days After' }];

	const isNormalInteger = (str) => /^\+?(0|[1-9]\d*)$/.test(str);

	const handleAddTiming = () => {
		if (!selectedTiming) return;
		if (!days || !isNormalInteger(days)) return;
		const newTiming = { days, timing: selectedTiming };
		const currentTiming = [...values.timingList];
		const inList = (currentTiming.filter(item => item === newTiming).length > 0);
		if (inList) {
			return;
		}
		currentTiming.push(newTiming);
		setFieldValue('timingList', currentTiming);
	};

	const removeTiming = (timing) => {
		const timingList = values.timingList.filter(item => item != timing);
		setFieldValue('timingList', timingList);
	};

	return (
		<Grid container direction="row" justify="center" alignItems="center">
			<p>Timing:</p>
			<Grid item xs={12} className="flexGrid">
				<TextField
					placeholder="Days"
					variant="outlined"
					value={days}
					onChange={e => setDays(e.target.value)}
					error={form.errors.timingList}
					fullWidth
				/>
			</Grid>
			<Grid item xs={12} className="flexGrid">
				<TextField
					onChange={(_, { props }) => setSelectedTiming(props.value)}
					error={form.errors.timingList}
					value={selectedTiming}
					select
					fullWidth
				>
					{notificationsTimes.map((nt) => {
						return <MenuItem value={nt.name}>{nt.name}</MenuItem>;
					})}
				</TextField>
				<Button variant="outlined" onClick={handleAddTiming}>Add</Button>
			</Grid>
			{values.timingList && values.timingList.length > 0 && (
				<Grid item xs={12}>
					<p>Notification Times:</p>
					<ChipsArray timing={values.timingList} removeTiming={removeTiming} />
				</Grid>
			)}
		</Grid>
	);
}

const RecipientList = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;
	div {
		display: flex;
		flex-direction: row;
		flex: 1;
		justify-content: space-between;
		margin-bottom: 8px;
		label {
			color: #48596B;
			font-size: 16px;
			font-weight: 400;
		}
		svg {
			cursor: pointer;
			color: #0072A2;
		}
	}
`;
const DeleteIcon = styled.span`
	width: 19px;
	height: 19px;
	background-size: cover;
	background-image: url(${DeleteSvg});
`;